import React from 'react';
import { Text } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import classes from './sceneCard.module.css';

type PlaceholderCardProps = {
    /** Call-to-action text, e.g. "Add scene" or "New scene". */
    label: string;
    /** Icon above the label; defaults to a plus. */
    icon?: React.ReactNode;
    onClick: () => void;
};

/**
 * The outlined "add / create" tile that sits alongside {@link SceneCard} at the
 * same aspect ratio — used for "Add scene" in a playlist strip and "New scene"
 * in the picker.
 */
const PlaceholderCard: React.FC<PlaceholderCardProps> = ({ label, icon, onClick }) => (
    <button
        type="button"
        className={`${classes.card} ${classes.placeholder} ${classes.clickable}`}
        onClick={onClick}
    >
        {icon ?? <IconPlus size={24} />}
        <Text className={classes.name} inherit>
            {label}
        </Text>
    </button>
);

export default PlaceholderCard;
